<template>
    <review-component v-bind="$props" v-on="$listeners">
<!--        <span style="display: inline-block; width: 80px;"/>-->

        &#60;button&#62;{{tr(component.text)}}&#60;/button&#62;

        <template v-if="component.link">
            &#60;a href="{{component.link.to || component.link.href}}"/&#62;
        </template>
    </review-component>
</template>

<script>
import ReviewComponent from "@components/review/review-component.vue";

export default {
    name: `review-component-button`,
    extends: ReviewComponent,
    components: {ReviewComponent}
}
</script>

<style lang="scss" scoped>
</style>
